import { render, staticRenderFns } from "./CourseClassNavItem.vue?vue&type=template&id=7d31585e&scoped=true"
import script from "./CourseClassNavItem.vue?vue&type=script&lang=js"
export * from "./CourseClassNavItem.vue?vue&type=script&lang=js"
import style0 from "./CourseClassNavItem.vue?vue&type=style&index=0&id=7d31585e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d31585e",
  null
  
)

export default component.exports